export default "__VITE_ASSET__DHlHktAG__"